export default __webpack_public_path__ + "static/media/node.8683d89c.png";